"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateBasicAuthHeader = void 0;
var encode_1 = require("../tools/encode");
function generateBasicAuthHeader(username, password) {
    var encoded = encode_1.toBase64(username + ":" + password);
    return "Basic " + encoded;
}
exports.generateBasicAuthHeader = generateBasicAuthHeader;
